import { useAppDispatch } from 'hooks/useAppDispatch';
import { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { FinanceService } from 'services/FinanceService';
import { Button } from 'ui/redesign/Button';
import { ButtonVariant } from 'ui/redesign/Button/constants';
import { CustomInput } from 'ui/redesign/CustomInput';
import { checkPayment } from './consts';
import { handleFileDownloadNew } from 'utils/helpers';

export const RefillBalanceModal: FC = () => {
  const dispatch = useAppDispatch();
  const {
    control,
    formState: { errors },
    clearErrors,
    getValues,
    handleSubmit,
    setError,
  } = useForm<{
    payment: string;
  }>({
    defaultValues: {
      payment: '',
    },
  });

  const onCloseFilters = () => {
    dispatch(modalActions.closeModal());
  };

  const { mutateAsync: getPaymentInvoiceFile } = useMutation({
    mutationFn: (sum: number) => {
      return FinanceService.getPaymentInvoiceFile(sum);
    },
    onSuccess: (response) => {
      toast.success('Счет сформирован успешно. Начинается загрузка...');
      handleFileDownloadNew(response.data);
    },
  });

  const confirmHandler = () => {
    const actualFormValues = getValues();
    const toastErrors: string[] = [];

    checkPayment(actualFormValues.payment, setError, toastErrors);

    if (toastErrors.length) {
      const onlyUnique = new Set(toastErrors);
      Array.from(onlyUnique).forEach((message: string) => {
        toast.error(message);
      });
      return;
    }

    getPaymentInvoiceFile(Number(actualFormValues.payment.replace(/\s+/g, '')));
    dispatch(modalActions.closeModal());
  };

  return (
    <form onSubmit={handleSubmit(confirmHandler)}>
      <div className="my-6 pr-2">
        <Controller
          name={`payment`}
          control={control}
          render={({ field }) => {
            const changeHandler = (value?: string) => {
              field.onChange(value);
              clearErrors && clearErrors(field.name);
            };
            return (
              <CustomInput
                label="Вознаграждение (по договору), руб.: 0,00"
                onChange={changeHandler}
                value={field.value}
                maxValue={999999999.99}
                decimal={2}
                errorMessage={errors?.payment?.message}
                isClearable
              />
            );
          }}
        />
      </div>
      <div className="flex flex-row-reverse gap-6">
        <Button type="submit">СФОРМИРОВАТЬ</Button>
        <Button type="button" variant={ButtonVariant.OUTLINE} onClick={onCloseFilters}>
          ОТМЕНА
        </Button>
      </div>
    </form>
  );
};
